export default "__VITE_ASSET__DSw$zIZx__"